package ru.villawonka.app.domain.usecase

import ru.villawonka.app.common.utils.Either
import ru.villawonka.app.domain.model.NetworkFailure
import ru.villawonka.app.domain.model.UserSettingsDomain
import ru.villawonka.app.domain.repository.UserRepository
import ru.villawonka.app.domain.service.UserSettingsService
import ru.villawonka.app.resources.AppResources

class UpdateUserSettingsUseCase(
    private val userSettingsService: UserSettingsService,
    private val userRepository: UserRepository,
) {

    suspend operator fun invoke(userSettings: UserSettingsDomain): Either<NetworkFailure, Unit> {
        AppResources.setLanguage(userSettings.language)
        return userRepository.updateSettings(userSettings).also {
            userSettingsService.onSettingsChangedNotifyAll()
        }
    }
}